import { useEffect, useState } from 'react'
import { useContractRead } from 'wagmi'
import ensRegistryABI from '../contract-abi.json'

export const useLastPosition = () => {
    const [lastPosition, setLastPosition] = useState(null)

    const readObject = useContractRead({
        addressOrName: process.env.REACT_APP_CONTRACT_ADDRESS,
        contractInterface: ensRegistryABI,
    }, 'lastPosition')

    useEffect(() => {
        if (readObject.isSuccess && readObject.data) {
            setLastPosition(readObject.data.toNumber())
        }
    }, [readObject])

    return { lastPosition, readObject };
}
